import { Variants } from 'framer-motion';

export const listVariants: Variants = {
  open: {
    transition: {
      type: 'spring',
      bounce: 0,
      duration: 0.3,
      delayChildren: 0.05,
      staggerChildren: 0.05,
    },
    height: 'auto',
  },
  closed: {
    transition: {
      type: 'spring',
      bounce: 0,
      duration: 0.3,
    },
    height: 0,
  },
};

export const rowVariants: Variants = {
  open: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 24 },
  },
  closed: { opacity: 0, y: -20, transition: { duration: 0.01 } },
};
